import React, { useState, useEffect, useMemo, useCallback } from "react";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import Poin from "../../Component/Poin/Poin";
import "./poinpage.css";

export default function PoinPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // ===== deteksi mobile + sinkron state default
  const getIsMobile = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 1024px)").matches;

  const [isMobile, setIsMobile] = useState(getIsMobile());

  useEffect(() => {
    const mql = window.matchMedia("(max-width: 1024px)");
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    // di mobile default tertutup; di desktop terbuka
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  // ===== terapkan kelas DOM untuk off-canvas mobile
  const applyDomClasses = useCallback(
    (open) => {
      const body = document.body;
      const sidebarEl = document.querySelector(".poin-page .sidebar");
      const overlayEl = document.querySelector(".poin-page .sidebar-overlay");
      if (isMobile) {
        if (open) {
          sidebarEl?.classList.add("is-mobile-open");
          overlayEl?.classList.add("is-visible");
          body.classList.add("lock-scroll");
        } else {
          sidebarEl?.classList.remove("is-mobile-open");
          overlayEl?.classList.remove("is-visible");
          body.classList.remove("lock-scroll");
        }
      } else {
        sidebarEl?.classList.remove("is-mobile-open");
        overlayEl?.classList.remove("is-visible");
        body.classList.remove("lock-scroll");
      }
    },
    [isMobile]
  );

  useEffect(() => {
    applyDomClasses(isSidebarOpen);
  }, [isSidebarOpen, applyDomClasses]);

  const toggleSidebar = () => setIsSidebarOpen((v) => !v);

  // ===== overlay click (mobile)
  const handleOverlayClick = () => setIsSidebarOpen(false);

  // ===== di mobile main selalu full; di desktop geser sesuai state
  const mainContentClass = useMemo(() => {
    if (isMobile) return "main-content sidebar-closed";
    return `main-content ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`;
  }, [isMobile, isSidebarOpen]);

  return (
    <div className="poin-page">
      <Sidebar isOpen={isSidebarOpen} />

      {/* overlay untuk off-canvas */}
      <div className="sidebar-overlay" onClick={handleOverlayClick} aria-hidden={!isSidebarOpen} />

      <div className={mainContentClass}>
        <Header toggleSidebar={toggleSidebar} />
        <div className="poin-content">
          <Poin />
        </div>
        <footer className="dashboard-footer">
          <p>@copyright 2025 - LacaKas</p>
        </footer>
      </div>
    </div>
  );
}
